import { type QueryClient } from "@tanstack/react-query";

import { GET_WORKER_REQUIREMENTS_URL } from "./useGetWorkerRequirements";

export function removeWorkerRequirementsFromCache(queryClient: QueryClient) {
  queryClient.removeQueries({
    queryKey: [GET_WORKER_REQUIREMENTS_URL],
  });
}
